import * as Api from '@Api/index';
import { BackendError } from '@Common/errors';

import type { PageProductData } from '@Pages/PageProduct/typings';
import type { ApiResponse } from '@Types/Api';
import type { ParameterValueData } from '@Types/Cart';

export interface AdditionalData {
  id: number;
  quantity: number;
}

export interface ModuleData {
  id: number;
  quantity: number;
}

export interface Params {
  productId: number;
  search?: string;
  pageData?: PageProductData;
  parameterValues?: ParameterValueData[];
  opts?: {
    additional?: AdditionalData[];
    module?: ModuleData[];
  };
}

interface BonusData {
  earnedAmount: number;
  extraBonus: boolean;
}
async function getBonuses(params: Params) {
  const { productId, search, pageData, parameterValues = [] } = params;
  const searchParams = new URLSearchParams(search);

  const selectedOptions: Record<string, string> = {};
  searchParams.forEach((value, key) => {
    selectedOptions[key] = value;
  });

  if (parameterValues.length > 0) {
    selectedOptions.variants = parameterValues.map((item) => item.id).join(',');
  }

  const url = `/cabinet/cart/get-configuration-bonus-amount`;
  const res = await Api.queryProxi<ApiResponse<BonusData>>(url, {
    method: 'POST',
    body: JSON.stringify({
      ...params.opts,
      ...(pageData && { isSetConfigurator: pageData.isConfigurator }),
      ...(Object.keys(selectedOptions).length > 0 && { selectedOptions }),
      shopProductId: productId,
    }),
  });

  if (!res.ok) throw new BackendError(url, res);

  return res.data;
}

export default getBonuses;
